"use client";

import { RotateCcw } from "lucide-react";
import { useTranslations } from "next-intl";
import { useEffect } from "react";

import { Reveal } from "@/components/motion/reveal";
import { PageTitle } from "@/components/shared/page-title";
import { Link } from "@/i18n/navigation";

// =============================================================================

export default function ErrorPage({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  const t = useTranslations("Error");

  useEffect(() => {
    console.error(error);
  }, [error]);

  return (
    <section className="container-page flex min-h-[85svh] flex-col justify-center pt-32">
      <p className="mb-6 font-mono text-sm text-muted-foreground">500</p>
      <PageTitle lines={[t("title"), t("titleAccent")]} />
      <Reveal delay={0.6} className="mt-8 max-w-md">
        <p className="text-lg text-muted-foreground">{t("description")}</p>
        <div className="mt-10 flex flex-wrap gap-3">
          <button
            type="button"
            onClick={reset}
            className="inline-flex items-center gap-2 rounded-full bg-foreground px-6 py-3 text-sm font-medium text-background transition-opacity hover:opacity-85"
          >
            <RotateCcw className="size-4" />
            {t("retry")}
          </button>
          <Link
            href="/"
            className="inline-flex items-center rounded-full border border-foreground/15 px-6 py-3 text-sm font-medium transition-colors hover:border-foreground/40"
          >
            {t("home")}
          </Link>
        </div>
      </Reveal>
    </section>
  );
}

// =============================================================================
